// client/src/v2/components/map/SchoolMarkersV2Layer.jsx
import React, { useMemo } from "react";
import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import { getSchoolMarkerIcon } from "./markers/markerIconCache";
import { buildMarkerData } from "./markers/buildMarkerData";

/**
 * Dotted ring under the focused pin.
 */
const HIGHLIGHT_DIV_ICON = L.divIcon({
  className: "v2-school-highlight-leaflet",
  html: '<div class="v2-school-highlight-disk" aria-hidden="true"></div>',
  iconSize: [52, 52],
  iconAnchor: [26, 26],
});

export default function SchoolMarkersV2Layer({
  schools,
  highlightSchoolId = null,
  onSchoolMarkerClick,
  ofstedBySchoolId = {},
}) {
  const markers = useMemo(() => {
    if (!Array.isArray(schools)) return [];

    return schools
      .map((s) => {
        const lat = Number(s.lat);
        const lon = Number(s.lon);
        if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

        const data = buildMarkerData(s, ofstedBySchoolId);
        return {
          ...data,
          pos: [lat, lon],
        };
      })
      .filter(Boolean);
  }, [schools, ofstedBySchoolId]);

  if (markers.length === 0) return null;

  return (
    <>
      {markers.map((m) => {
        const isHighlight =
          highlightSchoolId != null && m.id === highlightSchoolId;

        const icon = getSchoolMarkerIcon({
          gender: m.gender,
          phase: m.phase,
          ofstedGrade: m.ofstedGrade,
          isTopSchool: m.isTopSchool,
          schoolType: m.schoolType,
        });

        return (
          <React.Fragment key={`school:${m.id}`}>
            {isHighlight ? (
              <Marker
                position={m.pos}
                icon={HIGHLIGHT_DIV_ICON}
                interactive={false}
                zIndexOffset={400}
              />
            ) : null}
            <Marker
              position={m.pos}
              icon={icon}
              zIndexOffset={isHighlight ? 650 : 0}
              eventHandlers={
                onSchoolMarkerClick
                  ? {
                      click(e) {
                        L.DomEvent.stopPropagation(e);
                        onSchoolMarkerClick(m.id);
                      },
                    }
                  : undefined
              }
            >
              <Tooltip
                direction="top"
                offset={[0, -38]}
                opacity={1}
                className="v2-marker-tooltip-school"
              >
                {m.name}
              </Tooltip>
            </Marker>
          </React.Fragment>
        );
      })}
    </>
  );
}
